import script from "./HistoryIncomeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryIncomeTable.vue?vue&type=script&setup=true&lang=js"

import "./HistoryIncomeTable.vue?vue&type=style&index=0&id=52f42a78&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f42a78"]])

export default __exports__